import styled from 'styled-components';

export const TransportAndBrandedFaresContainer = styled.div<{ $isTransportNotAvailable?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer02};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  width: 100%;
  border-radius: 16px;
  padding: 16px 24px;
  justify-content: space-between;

  @media (min-width: 768px) {
    border-color: ${({ theme, $isTransportNotAvailable }) =>
      $isTransportNotAvailable
        ? theme.kallisto.color.border.static.borderWarningContrast
        : theme.kallisto.color.border.static.borderNeutral};
  }
`;

export const TransportDetailsContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
